import {Avatar, Box, Grid, IconButton, Menu, MenuItem, Stack, Tooltip, Typography} from "@mui/material";
import "./topBarStyles.css";
import * as React from "react";
import {APP_DATA} from "../../config/settings";
import AuthService from "../../services/AuthService";
import {useEffect, useState} from "react";
import userIcon from "../../asset/icons/user-c.png"

export default function TopBar() {

    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [user, setUser] = useState(null);
    useEffect(() => {
        // console.log("mounted");
        getUser();
    }, []);

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    const logOut = () => {
        const url =  window.location.origin + '/#' + APP_DATA.LOGIN_ROUTE;
        window.location.href= url;
        localStorage.clear();
    }
    const getUser = async () => {
        const res = await AuthService.user();
        setUser(res);
        // console.log(res);
    }
    return <Grid container className="container">
        <Grid item xs={6}>
            {/*<div className="logo-container">*/}
            {/*    <img src={logo} className="logo"/>*/}
            {/*</div>*/}
            <div className="brandTextContainer">
                <Typography variant={'p'} gutterBottom color={"#8c3b61"}><b>SmileFy Drive</b></Typography>
            </div>
        </Grid>
        <Grid item xs={6} className="driveUserStatusContainer">
            <Stack direction="row-reverse" spacing={1} >
                <Box sx={{ flexGrow: 0 }}>
                    <Tooltip title="Open settings">
                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                            <Avatar alt={user ? user.Name + " " + user.FamilyName : ''} src={userIcon} />
                        </IconButton>
                    </Tooltip>
                    <Menu
                        sx={{ mt: '45px' }}
                        id="menu-appbar"
                        anchorEl={anchorElUser}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                    >
                        <MenuItem onClick={handleCloseUserMenu}>
                            <Typography textAlign="center" fontSize="small">Profile</Typography>
                        </MenuItem>
                        <MenuItem onClick={logOut}>
                            <Typography textAlign="center" fontSize="small">Logout</Typography>
                        </MenuItem>
                    </Menu>
                </Box>
            </Stack>

        </Grid>
    </Grid>

}